const COOKIE_JWT_PAYLOAD = 'jwtPayload';

const config = {
  domain: 'royk.auth0.com',
  clientId: 'J5Mu7fSFraTWgQBz1WJgikpnuRnKRkaL',
};

const noId = 'no-id';

export { COOKIE_JWT_PAYLOAD, config, noId };
